/**
 * Enum representing different workflow modes.
 */

export enum WorkflowMode {
  /**
   * Mode for creating "new" payment preferences within a workflow.
   */
  Create = "create",

  /**
   * Mode for editing "existing" payment preferences within a workflow.
   */
  Edit = "edit",
} /**
 * Enum representing different create payment pref entry points
 */

export enum CreatePaymentPrefEntryPoint {
  /**
   * Entry point for switching an existing payment method out for another.
   */
  Switch = "switch",

  /**
   * Entry point for adding payment instructions to positions who do not have any instructions.
   */
  Add = "add",
} /**
 * Enum representing different workflow types.
 */

export enum WorkflowType {
  /**
   * Workflow related to accounts.
   */
  Account = "Account",

  /**
   * Workflow related to positions.
   */
  Position = "Position",

  /**
   * Workflow related to the LP Portal.
   */
  LPPortal = "LPPortal",
}
